import "../styles/home.scss";
import projects from "../utils/projects.json";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";

export default function Home() {
  const { t } = useTranslation();

  const user = JSON.parse(localStorage.getItem("user"));

  const isAllowed = (projectLink) => {
    const role = user?.role;

    const accessMap = {
      "/moah-audit": ["admin", "moah", "sales"],
      "/campaign-agent": ["admin", "marketing"],
      "/admin": ["admin"], // ✅ Admin-only access
    };

    return accessMap[projectLink]?.includes(role);
  };

  return (
    <>
      <div className="home-header">
        <p>{t("portal_subtitle")}</p>
      </div>

      <main className="projects">
        {projects.projects
          .filter((project) => isAllowed(project.link))
          .map((project) => (
            <a
              className="project-card"
              href={project.link}
              key={project.name.en}
            >
              <h2>{project.name[i18n.language]}</h2>
              <p>{project.description[i18n.language]}</p>
            </a>
          ))}
      </main>
    </>
  );
}
